(function ($) {
    'use strict';
    $('.aggregation-toggle').on('click', function() {
        $('#aggregation_search').toggleClass('aggregation_search--visible');
    });

    $('.item-list__show-more, .item-list__show-less').on('click', function() {
        $(this.parentElement).children('.item-list__show-more, .item-list__show-less').toggle();
        $(this.parentElement).children('.item-list__hidden').toggle();
    });

    $('.aggregation-item__aggregation-name').on('click', function() {
        $(this).parent('li').toggleClass('search-aggregation__aggregation-list__item--visible');
    });

    $('.js-search-aggregation-select').on('change', function () {
        if($(this).hasClass('js-nested-aggregation')){
            //Si l'aggregation parent passe à false, les checkboxs enfants prennent l'état du parent
            var input = $(this).find('.js-nested-aggregation-parent');
            if(!input.prop('checked')){
                $(this).find('input:checkbox').prop('checked', input.prop('checked'));
            }
        }
        var $form = $(this).closest('form');
        $form.submit();
    });

})(jQuery.noConflict());